export const FLOATING_SIGNUP_STATE_CHANGE_EVENT = 'pplx:floating-signup-state-change';
//# sourceMappingURL=floatingUpsellEvents.js.map